<template>

  <div class="wall-cells" :class="{ loading: this.$store.state.loading }">
    <BTCell @validate="validate" v-for="(cabcellData,index) in priceData"
            :key="index"
            :cellData="cabcellData"
            :calculateDt="cellsData"
            :index="index"
            :date="date"
    />
  </div>

</template>

<script>
import BTCell from "@/components/BookingTable/BTCell";
// import {dateFormat} from "@/dateFormat";

export default {
  name: 'BTWallCell',
  components: {
    BTCell
  },
  inject: ['officeId', 'selectData', 'mySelectData'],
  props: {
    date: String,
    priceData: Object,
    startTime: String,
    endTime: String,
    timeZone: String
  },
  data() {
    return {
      // priceData:this.getPriceData(),
      cellsData: {},
      startTimeLocal: "10:00",
      endTimeLocal: "22:00"
    }
  },
  beforeUpdate() {
    this.buildCalcData();
  },
  updated() {
    // console.log('WAll updated')
    // console.log(cellsData)
    //  this.validate();
  },
  created() {
    this.startTimeLocal = this.startTime ? this.startTime : this.startTimeLocal
    this.endTimeLocal = this.endTime ? this.endTime : this.endTimeLocal
    // console.log('created')
    // if(!this.$store.state.loading){
    this.buildCalcData();
    // }

  },

  computed: {

    getSelfBooking: function () {
      let data = this.$store.state.data.bookings
      if (this.isSet(data[this.date])) {
        return data[this.date]
      }
      return false
    },
  },

  watch: {
    // '$store.state.data': {
    //
    //   handler() {
    //     // console.log('WATCH')
    //     this.keyposfix++
    //   },
    //   deep: true
    // }
  },
  methods: {
    // getPriceData: function (){
    //   let date = new Date(this.date)
    //   let dayNum = date.getDay()
    //   let type = dayNum == 0 || dayNum == 6 ? 'weekend' : 'weekdays'
    //   // console.log(this.$store.state.data.prices[type])
    //   return this.$store.state.data.prices[type]
    // },
    validate() {
      // console.log('validate')
      // this.$emit("validate");
      this.buildCalcData();
    },

    isSet(val) {
      return typeof val !== 'undefined'
    },

    buildCalcData() {
      // console.log('buildCalcData')
      let
          res = []
          , oldPrice = null
          , oldBooking = false
          , _data = this.priceData
          // , _data = Object.assign({},this.cabData)
          , bookingData = this.getSelfBooking
          // , bookingData = Object.assign({},this.getSelfBooking)
          // , datenowStamp = Date.now()
          // , datenowStamp = dateFormat.getDateNowWithTimeZone().getTime()
          , startHour = Number(this.startTimeLocal.split(":")[0])
          , startMinute = Number(this.startTimeLocal.split(":")[1])
          , endHour = Number(this.endTimeLocal.split(":")[0])
          , endMinute = Number(this.endTimeLocal.split(":")[1])
          , fkey = false

      // текущее время с учетом timezone
      const timeZone = String(this.timeZone); // Часовой пояс
      const [hours, minutes] = timeZone.split(":").map(Number);
      const offsetMinutes = hours * 60 + (hours < 0 ? -minutes : minutes); // Минуты смещения

      const now = new Date();
      const utcTimestamp = now.getTime() + now.getTimezoneOffset() * 60 * 1000; // Метка времени в UTC
      const datenowStamp = utcTimestamp + offsetMinutes * 60 * 1000; // Учёт часового пояса

      for (var key in _data) {


        let
            d = _data[key]
            // , sKey = this.officeId + ':' + d.cabinetId + ':' + d.hour + ':' + d.minute
            , sKey = this.date + ':' + d.hour + ':' + d.minute
            , booking = bookingData && this.isSet(bookingData[d.hour]) && this.isSet(bookingData[d.hour][d.minute])
            , bookingParam = booking && bookingData[d.hour][d.minute]
            , myBooking = booking && bookingParam && bookingParam['isOwner']
            // , myBooking = booking //todo тест - раскомменировать когда будет my работать booking && bookingParam['isOwner']
            , minute = d.minute === '1/2' ? 0 : 30
            , display = d.hour >= startHour && d.hour <= endHour
            , viewPrice = d.price !== oldPrice || oldBooking !== Boolean(booking)
            , isLast = false
            , select = this.isSet(this.selectData[sKey])
            , mySelect = this.isSet(this.mySelectData[sKey])
            , cancelRetention = false

        if (
            (d.hour === startHour && minute === 0  && startMinute === 30) ||
            (d.hour === endHour && endMinute === 30 && minute !== 0) ||
            (endMinute === 0 && d.hour === endHour)
        ) {
          display = false;
        }

        if (booking) {
          let
              cancelStamp = Number(d.cancelTime) * 3600 * 1000
              , minute = bookingParam['minute'] == '2/2' ? '30' : '00'
              , currDate = bookingParam['date'] + 'T' + bookingParam['hour'] + ':' + minute + ':00'
              , stamp = Date.parse(currDate)
          // Делаем удержание если время отмены истекло
          // ввели разрешение отмены без удержания в течении 2 часов после создания
          // параметр canFullReturn отображает можно ли отменить или нельзя в течении 2 часов и далее по истечению максимального времени отмены

          if (!bookingParam['canFullReturn'] && !(datenowStamp < (stamp - cancelStamp))) {
            cancelRetention = true
          }
          // console.log(bookingParam,minute,currDate,stamp)
        }
        let brickMinute = d.minute == '2/2' ? '30' : '00'
        let _hour = d.hour < 10 ? '0' + d.hour : d.hour;
        // let brickTimeIso = this.$store.state.date+'T'+d.hour+':'+brickMinute+':00';
        let brickTimeIso = this.date + 'T' + _hour + ':' + brickMinute + ':00';
        let brickStamp = new Date(brickTimeIso).getTime()
        let outOfDate = brickStamp < datenowStamp
        // console.log(brickStamp,datenowStamp)


        /*
        * 1 - free
        * 2 - busy
        * 3 - my
        * 4 - selected
        * 5 - selmybooking
        * 6 - my expired // мой и уже время наступило
        */
        let status = 1
        status = !display ? 0 : status; // выходит за рамки времени бронирования
        status = booking ? 2 : status;
        status = myBooking ? 3 : status;
        status = select ? 4 : status;
        status = mySelect ? 5 : status;
        status = outOfDate ? 7 : status;
        status = myBooking && outOfDate ? 6 : status; // new

        // console.log(myBooking)
        if (key > 0 && viewPrice) {
          res[key - 1]['isLast'] = true;
        }


        res[key] = {
          outOfDate: outOfDate,
          display: display, // обрезка часов с 10 до 21, так как бронирование не принимает на 9 часов и 22
          viewPrice: viewPrice,
          isFirst: viewPrice,
          isEndWorkDay: d.hour >= 17,
          isLast: isLast,
          isBooking: booking,
          isMyBooking: myBooking,
          select: select,
          status: status,
          sKey: sKey,
          bookingParam: bookingParam,
          cancelRetention: cancelRetention
        };

        if (display && !outOfDate) {
          oldPrice = d.price
          oldBooking = booking
        }

        if(display === true){
          fkey = key
        }

      }

      // if (res && key in res) {
      //   res[key]['isLast'] = true;
      // }
      if (typeof res[fkey] !== 'undefined') {
        res[fkey]['isLast'] = true;
      }


      this.validateCalcData(res, this)

      this.cellsData = res
    },

    validateCalcData(res, _this) {

      let l = res.length

      res.forEach(function (item, index, array) {
        let itemPrev = index ? array[index - 1]['status'] : 0;
        let itemPrevPrev = index > 1 ? array[index - 2]['status'] : 0;
        let itemNext = index < (l - 1) ? array[index + 1]['status'] : 0;
        let itemNextNext = index < (l - 2) ? array[index + 2]['status'] : 0;
        let error = false;

        //1 hours
        if (item['status'] === 4 && (itemPrev === 1 || itemPrev === 2 || !itemPrev || itemPrev === 7) && (itemNext === 1 || itemNext === 2 || !itemNext)) {
          // res[index]['error'] = true;
          error = '1hours';
          // Отменяем ошибку "Нельзя бронировать 30 минут", если впереди и в конце занято
          if ((!itemPrev || itemPrev === 2 || itemPrev === 7) && (!itemNext || itemNext === 2)) {
            error = false;
          }
          // console.log('1 hours');
        }

        //RangeHour
        if (item['status'] === 1 && (itemPrev === 4 || itemPrev === 3) && (itemPrevPrev === 4 || itemPrevPrev === 3)
            && (itemNext === 4 || itemNext === 3) && (itemNextNext === 4 || itemNextNext === 3)) {
          error = 'RangeHour';
          // console.log('RangeHour');
        }

        //MyRangeHour
        if (item['status'] === 5 && itemPrev === 3 && itemNext === 3) {
          error = 'MyRangeHour';
          // console.log('MyRangeHour');
        }

        //MyOneHour
        if (item['status'] === 3 && itemPrev !== 3 && itemPrev !== 6 && itemNext !== 3) {
          let tmpError = error // сохраним значение error
          error = 'MyOneHour';

          // Отменяем ошибку "Нельзя бронировать 30 минут", если впереди и в конце занято
          if ((!itemPrev || itemPrev === 2) && (!itemNext || itemNext === 2)) {
            error = tmpError; // вернем значение error
          }
          // console.log('MyOneHour');
        }

        if (error) {
          _this.$store.dispatch('selector/setError', {
            sKey: item['sKey'],
            typeError: error,
            isMy: item['isMyBooking']
          })
        } else {
          _this.$store.dispatch('selector/deleteError', {
            sKey: item['sKey'],
            isMy: item['isMyBooking']
          })
        }
        // if(error){
        //   _this.$store.commit('selector/setError', {
        //     sKey:item['sKey'],
        //     typeError:error,
        //     isMy:item['isMyBooking']
        //   })
        // } else{
        //   _this.$store.commit('selector/deleteError', {
        //     sKey:item['sKey'],
        //     isMy:item['isMyBooking']
        //   })
        // }
      });
    },
  }
}
</script>

<style scoped>

.wall-cells {

  position: relative;
  display: flex;
  /*display: inline-flex;*/
  width: fit-content;
  border-top: 1px solid #f5f5f5;
  max-height: 4rem;
  opacity: 1;
  transition: opacity ease .7s;
}
.vertical .wall-cells{
  flex-direction: column;
  max-height: unset;
  width: calc(100% / 7);
  top:2px!important;
    margin-left: 1px;
    margin-right: 1px;

}
.wall-cells.loading {
  opacity: .3;
}

.wall-cells:last-child {
  border-bottom: 1px solid #f5f5f5;
}


@media (max-width: 670px) {
  /*.wall-cells-wrap{*/
  /*  padding-top: 2rem;*/
  /*}*/
  .wall-cells {
    /*margin-top: 2rem;*/
    will-change: transform;
  }
}
</style>